'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/navigation';

import {
  AddArticleDetailHighlightApiParams,
  ArticleDetailNewHighlightResponseItem,
  DeleteHighlightApiParams,
  PatchArticleDetailHighlightApiParams,
} from '../../apis';

import { clientAxios } from '@/shared/api';
import { ApiResponse } from '@/shared/types';

export const useDeleteHighlightMutation = () => {
  const router = useRouter();

  return useMutation({
    mutationFn: ({ highlightId }: DeleteHighlightApiParams) =>
      clientAxios.delete('/deleteHighlightApi/', {
        data: { highlightId },
      }),
    onSuccess: () => {
      router.refresh();
    },
  });
};

export const useAddHighlight = () => {
  const queryClient = useQueryClient();
  const router = useRouter();

  return useMutation({
    mutationFn: async (arg: AddArticleDetailHighlightApiParams) => {
      const res = await clientAxios.post<
        ApiResponse<ArticleDetailNewHighlightResponseItem>
      >('/addArticleDetailHighlightApi/', {
        ...arg,
      });

      return res.data.data.id;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['getProfileIdApi'],
      });
      router.refresh();
    },
  });
};

export const useUpdateHighlight = () => {
  const queryClient = useQueryClient();
  const router = useRouter();

  return useMutation({
    mutationFn: async (arg: PatchArticleDetailHighlightApiParams) => {
      const res = await clientAxios.post<
        ApiResponse<ArticleDetailNewHighlightResponseItem>
      >('/patchArticleDetailHighlightApi/', {
        ...arg,
      });

      return res.data.data.id;
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ['getProfileIdApi'],
        }),
        queryClient.refetchQueries({
          queryKey: ['getCollectionMyHighlightsApi'],
        }),
      ]);
      router.refresh();
    },
  });
};
